import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button, Popconfirm, message } from "antd";
import { EditOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import Axios from "../../../services/AxiosInterceptor";
import { useNavigate } from "react-router-dom";

const EventsList = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  // Fetch events
  const fetchEvents = async () => {
    setLoading(true);
    try {
      const res = await Axios.get("api/events_list");
      setEvents(res.data);
    } catch (err) {
      message.error("Failed to load events");
    }
    setLoading(false);
  };

  // Delete event
  const deleteEvent = async (id) => {
  try {
    await Axios.post("/delete-event", { id });   // ✔ send ID in body using POST
    message.success("Event deleted successfully");
    fetchEvents();
  } catch (err) {
    console.error(err);
    message.error("Delete failed");
  }
};


  useEffect(() => {
    fetchEvents();
  }, []);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => (date ? new Date(date).toLocaleDateString() : "—"),
    },
    {
      title: "Venue",
      dataIndex: "venue",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <span
          style={{
            padding: "4px 12px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: "600",
            color: "white",
            backgroundColor: status === "Expired" ? "#dc3545" : "#28a745",
          }}
        >
          {status || "Active"}
        </span>
      ),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px" }}>
          
                  {/* Edit Button */}
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() =>
              (window.location.href =  `Edit&View_Events/${record._id}`)
            }
          >
            Edit
          </Button>

          {/* Delete Button */}
          <Popconfirm
            title="Delete this event?"
            onConfirm={() => deleteEvent(record._id)}
          >
            <Button danger icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div>
      <h2>Events List</h2>
  <Button onClick={() => navigate("/Add_Events")}>
      Add Event +
    </Button>
          <Table
        dataSource={events}
        columns={columns}
        rowKey="_id"
        loading={loading}
      />
    </div>
  );
};

export default EventsList;
